import { addLastPrefixPT } from '../transforms/addLastPrefix';
import { capitalizeFirstLetter } from '../transforms/capitalizeFirstLetter';
import { removeDots } from '../transforms/removeDots';
import { uppercase } from '../transforms/uppercase';
import { overrideBaseLocale } from './base-config';
export var ptBR = overrideBaseLocale('pt-BR', {
    dayOfWeekShort: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots],
    },
    dayOfWeekShortUppercase: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots, uppercase],
    },
    dayOfWeekLongPropercase: {
        options: {
            weekday: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    dayOfWeekShortPropercase: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots, capitalizeFirstLetter],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixPT],
    },
    monthShort: {
        options: {
            month: 'short',
        },
        transforms: [removeDots],
    },
    monthShortUppercase: {
        options: {
            month: 'short',
        },
        transforms: [removeDots, uppercase],
    },
    monthLongPropercase: {
        options: {
            month: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    monthShortPropercase: {
        options: {
            month: 'short',
        },
        transforms: [capitalizeFirstLetter, removeDots],
    },
});
//# sourceMappingURL=pt-BR.js.map